import React from 'react';
import RightPanel from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

export default function ContentViewMeetingRoomParticipant(props) {
  let centerContent = {};
  let participantStatus = '';
  let telephone = '';
  let userHasNoCenterPanelContent = false;

  if (props.participantFormData.isGuestCaller) {
    participantStatus = APP.LANGUAGE.MeetingRoomPersonStatus.Guest;
    userHasNoCenterPanelContent = true;
  } else if (props.participantFormData.roles) {
    if (
      props.participantFormData.roles.length === 0 ||
      props.participantFormData.roles.indexOf(APP.LANGUAGE.MeetingRoomPersonStatus.OrgAdministrator) !== -1
    ) {
      participantStatus = APP.LANGUAGE.MeetingRoomPersonStatus.OrgAdmin;
    } else if (props.participantFormData.roles.indexOf(APP.LANGUAGE.MeetingRoomPersonStatus.GroupAdministrator) > -1) {
      participantStatus = APP.LANGUAGE.MeetingRoomPersonStatus.GroupAdmin;
    } else {
      participantStatus = APP.LANGUAGE.MeetingRoomPersonStatus.GroupMember;
    }
  }
  if (props.participantFormData.phone && props.participantFormData.phone != '') {
    telephone = (
      <span className="mrlxs">
        <i className="phone icon" />
        {props.participantFormData.phone}
      </span>
    );
  }

  let profileImage = (
    <img
      className="ui image profile "
      src={props.participantFormData.profileImageUrl || window.APP.IMAGES.ProfilePlaceholder.default}
    />
  );
  centerContent = (
    <div className="pdts  ">
      <div className="left-section-caller">{profileImage}</div>
      <div className="right-section-caller" />
    </div>
  );
  return (
    <Modal
      isSingleColumnModal={true}
      size={'small'}
      show={props.showViewMeetingRoomParticipantModal}
      hideWhenClickAway={false}
      className={
        'view-waiting-area-participant single-column-modal' +
        (userHasNoCenterPanelContent ? ' no-center-panel-content' : '')
      }
    >
      <PopupHeader
        title={props.participantFormData.name || ''}
        helpLink={APP.EXTERNAL_LINKS.ViewMeetingRoom.ParticipantInfo}
        subtitle={
          <span>
            {participantStatus} {telephone}
          </span>
        }
      />
      <div className="content">
        <div
          className={'main-ui-container meeting-room-create-update ' + (userHasNoCenterPanelContent ? ' mrrnull' : '')}
        >
          <div id="righthandfloatingpanel">
            {!userHasNoCenterPanelContent ? centerContent : ''}
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <RightPanel participantFormData={props.participantFormData} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
